import React, { useEffect, useRef } from 'react';
import { BrainCircuit, Loader2 } from 'lucide-react';
import ProductResultCard from './ProductResultCard';
import './SellerAssistantMessageList.css';

function parseProducts(msg) {
  if (!msg) return [];
  if (Array.isArray(msg.products)) return msg.products;
  if (Array.isArray(msg.products_snapshot)) return msg.products_snapshot;
  if (typeof msg.products_snapshot === 'string') {
    try {
      return JSON.parse(msg.products_snapshot);
    } catch {
      return [];
    }
  }
  return [];
}

function SellerAssistantMessageList({ messages, loading, waitingResponse, onUseProductInSearch }) {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, loading, waitingResponse]);

  if (loading) {
    return (
      <div className="seller-assistant-messages seller-assistant-messages-loading">
        <Loader2 size={24} className="seller-assistant-spinner" />
        <span>Carregando conversa...</span>
      </div>
    );
  }

  if (!messages.length && !waitingResponse) {
    return (
      <div className="seller-assistant-messages seller-assistant-messages-empty">
        <div className="seller-assistant-welcome-icon">
          <BrainCircuit size={32} />
        </div>
        <h4>Assistente de Vendas Pró Médico</h4>
        <p>Pergunte sobre produtos, estoque, preço ou indicação clínica. Eu busco também na descrição cadastrada de cada item.</p>
      </div>
    );
  }

  return (
    <div ref={scrollRef} className="seller-assistant-messages">
      {messages.map((msg) => {
        const isUser = msg.role === 'user';
        const products = !isUser ? parseProducts(msg) : [];

        return (
          <div
            key={msg.id || `${msg.role}-${msg.created_at}`}
            className={`seller-assistant-message ${
              isUser ? 'seller-assistant-message-user' : 'seller-assistant-message-assistant'
            }`}
          >
            {!isUser && (
              <div className="seller-assistant-message-avatar">
                <BrainCircuit size={14} />
              </div>
            )}
            <div className="seller-assistant-message-body">
              <div
                className={`seller-assistant-message-bubble ${
                  isUser
                    ? 'seller-assistant-message-bubble-user'
                    : 'seller-assistant-message-bubble-assistant'
                }`}
              >
                {msg.content}
              </div>
              {products.length > 0 && (
                <div className="seller-assistant-products">
                  {products.map((product) => (
                    <ProductResultCard
                      key={product.id || product.sku}
                      product={product}
                      onUseInSearch={onUseProductInSearch}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      })}

      {waitingResponse && (
        <div className="seller-assistant-message seller-assistant-message-assistant">
          <div className="seller-assistant-message-avatar">
            <BrainCircuit size={14} />
          </div>
          <div className="seller-assistant-message-body">
            <div className="seller-assistant-message-bubble seller-assistant-message-bubble-assistant seller-assistant-typing">
              <Loader2 size={14} className="seller-assistant-spinner" />
              Consultando catálogo...
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SellerAssistantMessageList;
